export default __webpack_public_path__ + "static/media/wee_logo.c88fde7a.svg";